import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { QuickSkeleton } from "~/areas/tasks/components/Task/Kubernetes/components/QuickSkeleton";
const styles = {
    container: css({
        display: "flex",
        flexDirection: "column",
        gap: space[16],
    }),
    manifest: css({
        height: `calc(${space[16]} * 27)`, // 432px,
        width: "100%",
    }),
    manifestHeader: css({
        height: `calc(${space[16]} * 3.75)`, // 60px,
        width: "100%",
    }),
};
export const ManifestViewerListLoadingSkeleton = () => (<div className={styles.container}>
        <div className={styles.manifestHeader}>
            <QuickSkeleton />
        </div>
        <div className={styles.manifest}>
            <QuickSkeleton />
        </div>
        <div className={styles.manifestHeader}>
            <QuickSkeleton />
        </div>
    </div>);
